export default "__VITE_ASSET__qJV1LAZi__"